import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SessionValuesComponent } from './session-values.component';

@NgModule({
	declarations: [SessionValuesComponent],
	imports: [CommonModule],
	exports: [SessionValuesComponent],
})
export class SessionsValuesModule {}
